import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { yunSheyuanEntries } from '@/mocks/jiuchou-business';

export default function YunSheyuan() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="云社员业务闭环"
            title="三个入口，一个节点身份"
            subtitle="可寻货 · 省钱，可卖货 · 生钱，可服务 · 挣钱。云社员通过三个入口形成「买货 + 卖货 + 服务」的完整闭环。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {yunSheyuanEntries.map((e, i) => (
            <Reveal key={e.title} delay={i * 90}>
              <div className="h-full p-6 rounded-lg bg-background-100 border border-background-200 flex flex-col">
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${e.icon} text-primary-600 text-2xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{e.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{e.desc}</p>
                <div className="mt-4 pt-4 border-t border-background-200 space-y-2">
                  {e.points.map((p) => (
                    <div key={p} className="flex items-center gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line text-accent-600"></i>
                      {p}
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}

          {/* 连接箭头（桌面） */}
        </div>

        <Reveal delay={200}>
          <div className="mt-10 flex flex-col md:flex-row items-center justify-center gap-3">
            {['买货', '卖货', '服务'].map((t, i) => (
              <div key={t} className="flex items-center gap-3">
                <div className="px-6 py-3 rounded-full bg-foreground-950 text-background-50 font-heading font-bold">
                  {t}
                </div>
                {i < 2 && <i className="ri-add-line text-primary-500 text-xl"></i>}
              </div>
            ))}
          </div>
          <p className="mt-6 text-center text-sm text-foreground-500">
            而不是传统电商只有：<span className="font-semibold text-foreground-950">买货。</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}